(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[858,5664],{

/***/ "./node_modules/next/dist/build/webpack/loaders/next-client-pages-loader.js?absolutePagePath=private-next-pages%2Fsettings%2Faccount%2Findex.tsx&page=%2Fsettings%2Faccount!":
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/settings/account",
      function () {
        return __webpack_require__("./src/pages/settings/account/index.tsx");
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ "./src/components/WrapperRoutes/AuthenticatedRoute.tsx":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ authenticatedRoute; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/react/jsx-runtime.js");
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./node_modules/next/router.js");
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var wagmi__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./node_modules/wagmi/dist/index.js");




const WagmiLoadedAuthenticatedRoute = (param)=>{
    let { WrappedComponent , ...props } = param;
    const { address: userAddress  } = (0,wagmi__WEBPACK_IMPORTED_MODULE_3__/* .useAccount */ .mA)();
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        if (!userAddress) {
            router.push({
                pathname: "/login",
                query: {
                    from: router.asPath
                }
            });
        }
    }, [
        userAddress,
        router
    ]);
    if (userAddress) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(WrappedComponent, {
            ...props
        });
    }
    return null;
};
const authenticatedRoute = (WrappedComponent)=>{
    const AuthenticatedRoute = (props)=>{
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(WagmiLoadedAuthenticatedRoute, {
                WrappedComponent: WrappedComponent,
                ...props
            })
        });
    };
    return AuthenticatedRoute;
};


/***/ }),

/***/ "./src/hooks/useWeb3Token.ts":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ useWeb3Token; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var wagmi__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./node_modules/wagmi/dist/index.js");
/* harmony import */ var _everipedia_web3_signer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./node_modules/@everipedia/web3-signer/dist/src/index.js");



const useWeb3Token = ()=>{
    const [token, setToken] = react__WEBPACK_IMPORTED_MODULE_0__.useState();
    const [loading, setLoading] = react__WEBPACK_IMPORTED_MODULE_0__.useState(false);
    const [error, setError] = react__WEBPACK_IMPORTED_MODULE_0__.useState();
    const [isReSignToken, reSignToken] = react__WEBPACK_IMPORTED_MODULE_0__.useState(false);
    const { data: signer  } = (0,wagmi__WEBPACK_IMPORTED_MODULE_2__/* .useWalletClient */ .py)();
    const generateNewTokenAndStore = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(async ()=>{
        if (!signer) return;
        const freshToken = await (0,_everipedia_web3_signer__WEBPACK_IMPORTED_MODULE_1__/* .sign */ .Xx)((msg)=>signer.signMessage({
                message: msg
            }), {
            statement: "Welcome to IQ.Wiki ! Click to sign in and accept the IQ.Wiki Terms of Service: https://everipedia.com/static/terms. This request will not trigger a blockchain transaction or cost any gas fees. Your authentication status will reset after 24 hours. ",
            expires_in: "1h"
        });
        localStorage.setItem("USER_TOKEN", freshToken);
        setToken(freshToken);
    }, [
        signer
    ]);
    const fetchStoredToken = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(()=>{
        const storedToken = localStorage.getItem("USER_TOKEN");
        if (storedToken) {
            const { address , body  } = (0,_everipedia_web3_signer__WEBPACK_IMPORTED_MODULE_1__/* .verify */ .T)(storedToken);
            if (address && body) {
                setToken(storedToken);
            }
        } else {
            throw new Error("No token found");
        }
    }, []);
    react__WEBPACK_IMPORTED_MODULE_0__.useEffect(()=>{
        const retrieveWeb3Token = async ()=>{
            if (isReSignToken) setError("");
            else reSignToken(false);
            const generateNewToken = async ()=>{
                setLoading(true);
                try {
                    await generateNewTokenAndStore();
                } catch (e) {
                    setError(e);
                }
                setLoading(false);
            };
            try {
                fetchStoredToken();
            } catch (e) {
                await generateNewToken();
            }
        };
        retrieveWeb3Token();
    }, [
        signer,
        isReSignToken,
        generateNewTokenAndStore,
        fetchStoredToken
    ]);
    return {
        token,
        loading,
        reSignToken,
        error
    };
};


/***/ }),

/***/ "./src/pages/settings/account/SignTokenMessage.tsx":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/react/jsx-runtime.js");
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./node_modules/@chakra-ui/react/node_modules/@chakra-ui/hooks/dist/index.esm.js");
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./node_modules/@chakra-ui/layout/dist/index.esm.js");
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("./node_modules/@chakra-ui/icon/dist/index.esm.js");
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("./node_modules/@chakra-ui/modal/dist/index.esm.js");
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("./node_modules/@chakra-ui/button/dist/index.esm.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var react_icons_ri__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("./node_modules/react-icons/ri/index.esm.js");




const SignTokenMessage = (param)=>{
    let { error , reopenSigningDialog , message  } = param;
    const { isOpen , onOpen , onClose  } = (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .useDisclosure */ .qY)();
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (error) onOpen();
    }, [
        error,
        onOpen
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Center */ .M5, {
                p: 4,
                my: "25vh",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .VStack */ .gC, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Icon */ .JO, {
                            as: react_icons_ri__WEBPACK_IMPORTED_MODULE_5__/* .RiSettings4Line */ .nj4,
                            fontSize: 42
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Heading */ .X6, {
                            textAlign: "center",
                            children: "Authenticate to continue"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Text */ .xv, {
                            pb: 4,
                            maxW: "380px",
                            textAlign: "center",
                            children: message || "To make changes to your profile, authenticate your wallet to continue."
                        })
                    ]
                })
            }),
            isOpen && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .Modal */ .u_, {
                isOpen: isOpen,
                isCentered: true,
                onClose: onClose,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .ModalOverlay */ .ZA, {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .ModalContent */ .hz, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .ModalHeader */ .xB, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .HStack */ .Ug, {
                                    justifyContent: "space-between",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .HStack */ .Ug, {
                                        spacing: 4,
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Center */ .M5, {
                                                bgColor: "dimColor",
                                                boxSize: "35px",
                                                borderRadius: "full",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Icon */ .JO, {
                                                    as: react_icons_ri__WEBPACK_IMPORTED_MODULE_5__/* .RiErrorWarningFill */ .oji,
                                                    fontSize: 25
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Heading */ .X6, {
                                                fontSize: "25px",
                                                children: "Notice"
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .ModalCloseButton */ .ol, {
                                m: 2
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .ModalBody */ .fe, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .VStack */ .gC, {
                                    pb: 4,
                                    spacing: 4,
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Text */ .xv, {
                                            textAlign: "center",
                                            children: "Sign the prompt to make changes to your profile page. Rejecting the prompt will prevent access to your profile settings page."
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .Button */ .zx, {
                                            variant: "outline",
                                            onClick: ()=>reopenSigningDialog(true),
                                            children: "Try again"
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (SignTokenMessage);


/***/ }),

/***/ "./src/pages/settings/account/index.tsx":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ account; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__("./node_modules/react/jsx-runtime.js");
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("./node_modules/react/index.js");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var index_esm = __webpack_require__("./node_modules/@chakra-ui/layout/dist/index.esm.js");
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__("./node_modules/next/router.js");
// EXTERNAL MODULE: ./src/components/Elements/index.ts + 6 modules
var Elements = __webpack_require__("./src/components/Elements/index.ts");
;// CONCATENATED MODULE: ./src/components/Settings/SettingNavButton.tsx




const SettingNavButton = (param)=>/*#__PURE__*/ {
    let { text , Icon , tabName , isActive  } = param;
    return (0,jsx_runtime.jsxs)(Elements/* Link */.rU, {
        href: "/settings/account?tab=".concat(tabName),
        display: "flex",
        justifyContent: "left",
        alignItems: "center",
        gap: 4,
        bgColor: isActive ? "brand.700" : "transparent",
        color: isActive ? "white" : "linkColor",
        p: 4,
        _hover: !isActive ? {
            color: "linkHoverColor"
        } : {},
        width: "250px",
        borderRadius: "lg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                size: "20px"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                fontWeight: "bold",
                children: text
            })
        ]
    });
};
/* harmony default export */ var Settings_SettingNavButton = (SettingNavButton);

// EXTERNAL MODULE: ./node_modules/react-icons/fa/index.esm.js
var fa_index_esm = __webpack_require__("./node_modules/react-icons/fa/index.esm.js");
// EXTERNAL MODULE: ./src/hooks/useWeb3Token.ts
var useWeb3Token = __webpack_require__("./src/hooks/useWeb3Token.ts");
// EXTERNAL MODULE: ./src/services/profile/utils.ts
var utils = __webpack_require__("./src/services/profile/utils.ts");
// EXTERNAL MODULE: ./node_modules/wagmi/dist/index.js + 25 modules
var dist = __webpack_require__("./node_modules/wagmi/dist/index.js");
// EXTERNAL MODULE: ./src/services/profile/index.tsx + 1 modules
var profile = __webpack_require__("./src/services/profile/index.tsx");
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__("./node_modules/next-seo/lib/next-seo.module.js");
;// CONCATENATED MODULE: ./src/components/SEO/SettingPage.tsx



const SettingsPageHeader = (param)=>/*#__PURE__*/ {
    let { username  } = param;
    return (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
        title: "Settings -".concat(username, " "),
        description: "Update your profile and notification settings -".concat(username),
        canonical: "https://iq.wiki/settings/account",
        openGraph: {
            title: "Settings",
            description: "Update your profile and notification settings"
        },
        twitter: {
            cardType: "summary_large_image",
            handle: "@IQWiki",
            site: "IQWiki"
        }
    });
};
/* harmony default export */ var SettingPage = (SettingsPageHeader);

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__("./node_modules/next/dynamic.js");
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/utils/WalletUtils/getUserAddressFromCache.ts
var getUserAddressFromCache = __webpack_require__("./src/utils/WalletUtils/getUserAddressFromCache.ts");
// EXTERNAL MODULE: ./src/pages/settings/account/SignTokenMessage.tsx
var SignTokenMessage = __webpack_require__("./src/pages/settings/account/SignTokenMessage.tsx");
// EXTERNAL MODULE: ./src/components/WrapperRoutes/AuthenticatedRoute.tsx
var AuthenticatedRoute = __webpack_require__("./src/components/WrapperRoutes/AuthenticatedRoute.tsx");
;// CONCATENATED MODULE: ./src/pages/settings/account/index.tsx















const NotificationSettings = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(6788), __webpack_require__.e(6422), __webpack_require__.e(557), __webpack_require__.e(7135), __webpack_require__.e(7500)]).then(__webpack_require__.bind(__webpack_require__, "./src/components/Settings/NotificationSettings.tsx")), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/("./src/components/Settings/NotificationSettings.tsx")
            ]
    }
});
const ProfileSettings = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(5172), __webpack_require__.e(1270)]).then(__webpack_require__.bind(__webpack_require__, "./src/components/Settings/ProfileSettings/index.tsx")), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/("./src/components/Settings/ProfileSettings/index.tsx")
            ]
    }
});
const AdvancedSettings = dynamic_default()(()=>__webpack_require__.e(/* import() */ 7105).then(__webpack_require__.bind(__webpack_require__, "./src/components/Settings/AdvancedSettings.tsx")), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/("./src/components/Settings/AdvancedSettings.tsx")
            ]
    }
});
const Settings = ()=>{
    const { query  } = (0,router.useRouter)();
    const { tab  } = query;
    const { token , reSignToken , error  } = (0,useWeb3Token/* useWeb3Token */.A)();
    const { address: userAddress  } = (0,dist/* useAccount */.mA)();
    const { setAccount , profileData  } = (0,utils/* useUserProfileData */.Cf)(utils/* UserProfileFetchOptions.WITH_ALL_SETTINGS */.Ky.WITH_ALL_SETTINGS);
    (0,react.useEffect)(()=>{
        if (userAddress && token) {
            profile/* profileApiClient.setHeader */.$d.setHeader("authorization", token);
            setAccount(userAddress);
        }
    }, [
        userAddress,
        setAccount,
        token
    ]);
    if (!token) return /*#__PURE__*/ (0,jsx_runtime.jsx)(SignTokenMessage["default"], {
        reopenSigningDialog: reSignToken,
        error: error
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SettingPage, {
                username: userAddress
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* HStack */.Ug, {
                alignItems: "stretch",
                pb: 8,
                my: -8,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                        display: {
                            base: "none",
                            xl: "block"
                        },
                        p: 12,
                        borderRightWidth: "1px",
                        pr: 8,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                fontSize: "sm",
                                letterSpacing: "wide",
                                opacity: "0.8",
                                fontWeight: "bold",
                                mb: 5,
                                children: "SETTINGS"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* VStack */.gC, {
                                spacing: 4,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Settings_SettingNavButton, {
                                        text: "Profile",
                                        Icon: fa_index_esm/* FaUserCircle */.m3W,
                                        tabName: "profile",
                                        isActive: tab === "profile" || !tab
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Settings_SettingNavButton, {
                                        text: "Notifications",
                                        Icon: fa_index_esm/* FaBell */.Z3q,
                                        tabName: "notifications",
                                        isActive: tab === "notifications"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Settings_SettingNavButton, {
                                        text: "Advanced Settings",
                                        Icon: fa_index_esm/* FaPlusSquare */.ymq,
                                        tabName: "advanced",
                                        isActive: tab === "advanced"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* VStack */.gC, {
                        ml: "0 !important",
                        p: {
                            base: 4,
                            md: 10,
                            lg: 12
                        },
                        pt: {
                            base: 14,
                            md: 20,
                            lg: 24
                        },
                        w: "100%",
                        spacing: 8,
                        align: "left",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Heading */.X6, {
                                textTransform: "capitalize",
                                children: [
                                    tab || "Profile",
                                    " Settings"
                                ]
                            }),
                            (tab === "profile" || !tab) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileSettings, {
                                settingsData: profileData
                            }),
                            tab === "notifications" && /*#__PURE__*/ (0,jsx_runtime.jsx)(NotificationSettings, {
                                address: userAddress || (0,getUserAddressFromCache/* getUserAddressFromCache */.X)()
                            }),
                            tab === "advanced" && /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvancedSettings, {})
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var account = (dynamic_default()(()=>Promise.resolve((0,AuthenticatedRoute/* authenticatedRoute */.H)(Settings)), {
    ssr: false
}));


/***/ }),

/***/ "?d36c":
/***/ (function() {

/* (ignored) */

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5445,5675,2192,7249,8764,5619,4095,4235,8283,9774,2888,179], function() { return __webpack_exec__("./node_modules/next/dist/build/webpack/loaders/next-client-pages-loader.js?absolutePagePath=private-next-pages%2Fsettings%2Faccount%2Findex.tsx&page=%2Fsettings%2Faccount!"); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);